/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ticketsstudentbadge2Inputs */

const en_ticketsstudentbadge2 = /** @type {(inputs: Ticketsstudentbadge2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Students`)
};

const de_ticketsstudentbadge2 = /** @type {(inputs: Ticketsstudentbadge2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Studierende`)
};

/**
* | output |
* | --- |
* | "Students" |
*
* @param {Ticketsstudentbadge2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const ticketsstudentbadge2 = /** @type {((inputs?: Ticketsstudentbadge2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ticketsstudentbadge2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ticketsstudentbadge2(inputs)
	return de_ticketsstudentbadge2(inputs)
});
export { ticketsstudentbadge2 as "ticketsStudentBadge" }